module.exports = __webpack_public_path__ + "static/media/goalPhoto.4f453812.jpg";